export const CARD_TITLE_IMG_SOURCES = {
  helloGift: 'https://m.hellobike.com/resource/gallery/847/ThV4ygaG_hellosongni.png', // 哈啰送你
  surprisedPrice: 'https://m.hellobike.com/resource/gallery/847/vBBatjFW_jinxiyouhui.png', // 惊喜优惠
  openAliPasswordFreePay: 'https://m.hellobike.com/resource/gallery/847/qwegW-MA_Frame_46%20(1).png', // 开通支付宝免密支付
  hasOpenAliPasswordFreePay: 'https://m.hellobike.com/resource/gallery/847/gsAKMTk0_Frame_47.png', // 已开通支付宝免密支付
  surprisedSelectOne: 'https://m.hellobike.com/resource/gallery/847/NaJYelPa_Frame_42.png', // 惊喜三选一
  receiveSuccess: 'https://m.hellobike.com/resource/gallery/847/HG9CoTJk_give-success.png', // 领取成功
};

export const BIG_CARD_BG = {
  cardCoupon: 'https://m.hellobike.com/resource/gallery/847/TZgjpUZbVC.png', // 优惠券
  cardBike: 'https://m.hellobike.com/resource/gallery/847/yf1eJCK-39.png', // 骑行卡
};

export const JUMP_URL_SOURCES = {
  bikeHome: 'hellobike://hellobike.com/app/home', // 哈啰单车-首页
};
